import React, { useContext } from 'react';
import classNames from 'classnames';
import { Context } from '../../../context/AppContext';
import './styles.css';

const Wrapper = ({ children }) => {
  const {
    media: { mobile },
  } = useContext(Context);
  return (
    <div
      className={classNames('BusinessesList__Wrapper__root', {
        'BusinessesList__Wrapper__root--mobile': mobile,
      })}
    >
      {children}
    </div>
  );
};

export default Wrapper;
